import { render, staticRenderFns } from "./CaseCard.vue?vue&type=template&id=a5d44aaa&scoped=true&"
import script from "./CaseCard.vue?vue&type=script&lang=js&"
export * from "./CaseCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseCard.vue?vue&type=style&index=0&id=a5d44aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d44aaa",
  null
  
)

export default component.exports